import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export interface KvkkDeclarationFile {
  FileName: string
  ContentBase64: string
}

export class GetCreditCardDeclarationApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      // Admin controller [Route("admin/dealer")] altında; diğer admin servisleriyle aynı önek.
      url: 'admin/dealer/creditCardDeclaration',
      requesterInfo,
    })
  }

  public async getDeclaration(id: number): Promise<KvkkDeclarationFile> {
    return await this.getAsync<KvkkDeclarationFile>(String(id))
  }
}
